import styles from './TooltipConstraints.module.css'
import IconCheck from '@/assets/img/Icon_Check.svg'
import IconCross from '@/assets/img/Icon_Cross.svg'
import { useTranslations } from 'next-intl'

type TooltipConstraintsProps = {
	validations: any[]
}

export default function TooltipConstraints({ validations } : TooltipConstraintsProps) {
	const t = useTranslations('Validators')
	
	return (    
		validations.length === 0 || validations.every(v => !v.show) ? '' :
		<div data-testid="TooltipConstraints">
			{validations.map((constraint, i) => {
				if (!constraint.show) return null
				return (
					<div key={i} className={styles.msgWrapper} data-testid="InfoTooltip_messageWrapper">
						{constraint.success && <IconCheck className={`${styles.tooltipIcon} ${styles.success}`}/>}
						{!constraint.success && <IconCross className={`${styles.tooltipIcon}`}/>}
						<span className={`bodyTextSmallStrong ${constraint.success ? styles.success : ''} ${styles.msg}`}>{t(constraint.msg, constraint.params)}</span>
					</div>
				)
			})}
		</div>
	)
}